<template>
  <el-dialog title="实际价格批量创建" :visible.sync="dialogVisible" width="400px" top="32vh" center>
    <div>
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="8" class="font-blod">下载excel模版</el-col>
        <el-col :span="8">
          <el-button type="primary" @click="downloadExcel" size="medium">
            <div class="btnclass">
              <img src="../../../assets/download.png" alt="">
              <span>excel模版下载</span>
            </div>
          </el-button>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="8" class="font-blod">导入excel</el-col>
        <el-col :span="8">
          <file-upload ref="fileupload" @addUpload="importUpdateStockByExcel" :title="'+导入excel文件'" :limit="1"
            size="medium" />
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="tableBtn">
      <div @click="cancelExcel">取 消</div>
      <div @click="submitExcel">确认导入</div>
    </div>
  </el-dialog>
</template>
<script>
import FileUpload from '@/components/Upload/fileUpload'
export default {
  components: {
    FileUpload
  },
  data () {
    return {
      /**
       * dialogVisible 弹框状态 false true
       * loading 上传导入状态 false true
       * upLoadData 上传的文件
       */
      dialogVisible: false,
      loading: false,
      upLoadData: ''
    }
  },
  methods: {
    // 打开弹框
    openDialog () {
      this.dialogVisible = true
    },
    // 下载模版
    downloadExcel () {
      const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/downloadImportTemplate'
      this.global.exportExcel(url, {}, '实际价格模版').catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message)
        })
      })
    },
    // 导入存储文件事件
    importUpdateStockByExcel (item) {
      this.upLoadData = item
    },
    // 确认提交
    submitExcel () {
      if (!this.global.handleEmptyData(this.upLoadData)) {
        if (this.loading) {
          return 
        }
        this.loading = true
        let formData = new FormData();
        formData.append("file", this.upLoadData.file)
        const url = '/autoapp-default-server-recovery/api/tbl-actual-price-control/importData'
        this.HttpService.post(url, formData).then(res => {
          if (res.statusCode != 200) {
            this.$message.error(res.message)
          } else {
            this.$message.success('导入成功')
            this.$emit('opera-success')
          }
          this.loading = false
          this.cancelExcel()
        })
      } else {
        this.$message.error('请上传文件')
      }
    },
    // 取消提交
    cancelExcel () {
      this.$refs.fileupload.$refs.upload.clearFiles()
      this.upLoadData = {}
      this.dialogVisible = false
    },
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.orderEdit {
  width: 100%;
}

.tableBtn {
  cursor: pointer; // 悬浮时变手指
}

.btnclass {
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}</style>


// WEBPACK FOOTER //
// src/views/recoveryManagement/component/BatchAddActualPriceDialog.vue